export let DemoMerchantPayoutResponse: any = {
    "success": true,
    "message": "Request Completed Successfully",
    "responseStatusCode": 903,
    "data": [
        {
            "orderNumber": "ORD-10231",
            "customerId": "CUST-1001",
            "customerName": "John Carter",
            "orderDate": "2026-06-18T10:09:01.1079738",
            "totalAmountPaid": 145.50,
            "paymentGatewayFee": 4.52,
            "platformFee": 2.91,
            "refundAmount": 0.0,
            "netPayout": 138.07
        },
        {
            "orderNumber": "ORD-10232",
            "customerId": "CUST-1002",
            "customerName": "Maria Gomez",
            "orderDate": "2026-06-19T14:22:10.0000000",
            "totalAmountPaid": 89.00,
            "paymentGatewayFee": 2.88,
            "platformFee": 1.78,
            "refundAmount": 20.00,
            "netPayout": 64.34
        },
        {
            "orderNumber": "ORD-10233",
            "customerId": "CUST-1003",
            "customerName": "David Lee",
            "orderDate": "2026-06-20T09:15:42.0000000",
            "totalAmountPaid": 312.75,
            "paymentGatewayFee": 9.36,
            "platformFee": 6.26,
            "refundAmount": 0.0,
            "netPayout": 297.13
        },
        {
            "orderNumber": "ORD-10234",
            "customerId": "CUST-1001",
            "customerName": "John Carter",
            "orderDate": "2026-06-21T16:48:05.0000000",
            "totalAmountPaid": 54.99,
            "paymentGatewayFee": 1.89,
            "platformFee": 1.10,
            "refundAmount": 0.0,
            "netPayout": 52.00
        }
    ],
    "code": "IMS0122903",
    "totalRecords": 4,
    "elapsedTime": "31002",
    "showThisMessage": false
}

export let DemoMerchantPayoutSummaryResponse: any = {
    "success": true,
    "data": {
        "totalSales": 602.24,
        "totalOrders": 4,
        "totalPlatformFeesCollected": 12.05,
        "totalNetPayout": 551.54
    }
}
